import React, { useContext, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { AppContext } from "store/AppContext";
import OpinKosningCard from './OpinKosningCard';

const useStyles = makeStyles(theme => ({
  grid: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  cardItem: {
    display: 'flex',
  },
  titleSection: {
    textAlign: 'left',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  titleText: {
    textTransform: 'uppercase',
    borderBottom: '3px solid',
    borderBottomColor: theme.palette.primary.main,
  }
}));

export default function OpnarKosningar(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { opnarKosningar } = props;

  const handleSelect = (kosning) => {
    context.activeKosning.set(kosning);
  }

  return (
    <Fragment>
      <Typography className={classes.titleSection} variant="h5" component="h2">
        <strong className={classes.titleText}>Opnar kosningar</strong>
      </Typography>

      {opnarKosningar[0] ? (
        <Grid container className={classes.grid} spacing={3}>
          {opnarKosningar.map((k) => (
            <Grid
              item
              xl={4}
              lg={4}
              md={6}
              xs={12}
              className={classes.cardItem}
              key={k.id}
            >
              <OpinKosningCard kosning={k} handleSelect={handleSelect} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <div style={{ marginTop: '24px' }}>
          <Typography>Ekki hefur verið opnað fyrir skráningu í neina kosningu</Typography>
        </div>
      )}
    </Fragment>
  );
}
